import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiRoutes} from 'core/enums/api.routes';
import {StoreService} from 'shared/store/store.service';
import {environment} from '../../environments/environment';
import {SnackbarService} from './snackbar/snackbar.service';
import {OperationStatus} from 'shared/components/operation-snackbar/operation-snackbar.component';
import {UserRoles} from '../features/main-page/types';
import {selectSelectedOrganizationId} from '../shared/store/user-info/user-info.selector';
import {Store} from '@ngrx/store';
import {saveUserPermissions} from '../shared/store/user-info/user-info.actions';
import {selectUserPermissions} from '../shared/store/user-info/user-info.selector';

type Result = {
  affected: number;
};

@Injectable({providedIn: 'root'})
export class LoginService {
  constructor(
    private readonly http: HttpClient,
    private readonly storeService: StoreService,
    private readonly snackbarService: SnackbarService,
    private readonly store: Store,
  ) {
    this.selectedOrganization$.subscribe((subs) => {
      if (subs) this.getUserRoles();
    });
  }

  selectedOrganization$ = this.store.select(selectSelectedOrganizationId);

  TCMR_API = environment.apiUrl;

  refreshUserData() {
    return this.http
      .put<Result>(ApiRoutes.PUT_LOGIN, {})
      .subscribe((result: Result) => {
        if (result.affected) {
          this.storeService.refreshOrganizationStore();
          return;
        }
        this.snackbarService.open(
          'COMMON.NO_USER_ROLES_ERROR_MESSAGE',
          OperationStatus.ERROR,
        );

      });
  }

  getUserRoles() {
    this.http
      .get<UserRoles>(ApiRoutes.GET_USER_PERMISSIONS)
      .subscribe((roles) => {
        this.store.dispatch(saveUserPermissions({permissions: roles}));
      });
  }
}
